import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../../helper'
const actions = {
    getRenewPacksDetail: (context, filterData) => {
        let url = '/subscriber/v1/plan/active'
        return new Promise((resolve, reject) => {
            let queryStr = ''
            if (filterData.productstatus) {
                queryStr = makeQueryStringDync(filterData)
            }
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error)
                });
        });
    },


    payDPCustomer: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log("payload ", payload)
            let data = makeQueryFormDataDyn(payload);

            fetch(context.getters.baseUrl + "/subscriber/v1/plan/plannew", {
                method: "POST",
                body: data
            })
                .then(errorServeiceHandler)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    console.log("error", error);
                    reject(error);
                });
        });
    }


};

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/mypacks/renew.js